module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "block-title align-center"
  }, [_vm._v(_vm._s(_vm.sectionTitle[_vm.actualLanguage]))]), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "area",
      "height": "350",
      "options": _vm.chartOptions,
      "series": _vm.chartDataSeries
    }
  })], 1)])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd3626aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cost_splitting/GraphApexTimeLine.vue
// module id = 1580
// module chunks = 4